import React from 'react';
import { motion } from 'framer-motion';
import { FiExternalLink, FiZap, FiUsers, FiImage } from 'react-icons/fi';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "LoL Dodge Game",
      description: "A training tool for famous MOBA games like League of Legends. Improve your mechanics or just warm up by playing one of our games.",
      url: "loldodgegame.com",
      icon: <FiZap />,
      color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      tags: ["Gaming", "Training", "Web App"]
    },
    {
      id: 2,
      title: "One Stream RPG",
      description: "An RPG you play through Twitch, meaning every viewer is a player interacting with the stream and controlling their own character.",
      url: "onestreamrpg.com",
      icon: <FiUsers />,
      color: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      tags: ["RPG", "Twitch", "Interactive"]
    },
    {
      id: 3,
      title: "PurePNG",
      description: "A stock platform for PNG images providing high-quality transparent images for designers and developers.",
      url: "purepng.com",
      icon: <FiImage />,
      color: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      tags: ["Stock Photos", "PNG", "Design"]
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const projectVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  return (
    <section id="projects" className="projects">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="section-header"
        >
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-subtitle">
            Showcasing innovative solutions and creative digital experiences
          </p>
        </motion.div>

        <motion.div
          className="projects-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {projects.map((project) => (
            <motion.div
              key={project.id}
              className="project-card"
              variants={projectVariants}
              whileHover={{ 
                y: -10,
                transition: { duration: 0.3 }
              }}
            >
              <div className="project-content">
                <motion.div 
                  className="project-icon"
                  style={{ background: project.color }}
                  whileHover={{ rotate: 360 }}
                  transition={{ duration: 0.6 }}
                >
                  {project.icon}
                </motion.div>
                
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                
                <div className="project-tags">
                  {project.tags.map((tag, index) => (
                    <span key={index} className="project-tag">{tag}</span>
                  ))}
                </div>
                
                <motion.a
                  href={`https://${project.url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span>Visit Website</span>
                  <FiExternalLink />
                </motion.a>
              </div>
              
              <div className="project-glow" style={{ background: project.color }}></div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
